import Sidebar from "../Sidebar/Sidebar";
import CloseIcon from "../../images/icon_close.svg";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import {
  CloseButton,
  Container,
  PMessage,
  StatusCard,
  StatusInfo,
  VolanteInfo,
} from "./AdminInvoiceStatusSidebarStyles";
import { StatusCommon } from "../../common/components/StatusCommon/StatusCommon";

export const AdminInvoiceStatusSidebar = (props) => {
  const { volante, onOutsideClick } = props;
  const { status } = volante;
  const { problems, warnings } = status;
  const numberProblems = problems.length;
  return (
    <Sidebar onOutsideClick={onOutsideClick}>
      <Container>
        <VolanteInfo>
          {volante?.quotationNum && (
            <p className="quotation-id">{`${volante?.quotationNum}`}</p>
          )}
          <CloseButton onClick={onOutsideClick}>
            <img src={CloseIcon} alt="Close" />
          </CloseButton>
          <p className="importer-name">
            {volante.importer || volante.consigneeName}
          </p>
          <div style={{ width: "13.3rem" }}>
            <StatusCommon
              label={`${
                numberProblems === 0 ? "SIN" : numberProblems
              } RESTRICCI${numberProblems === 1 ? "ÓN" : "ONES"}`}
              status={numberProblems > 0 ? "problem" : "ok"}
            />
          </div>
        </VolanteInfo>
        <StatusInfo>
          {numberProblems === 0 && (
            <StandaloneMessage>
              Este volante no tiene ninguna restricción.
            </StandaloneMessage>
          )}

          {problems.map((problem, index) => {
            return (
              <StatusCard key={index}>
                <StatusCommon
                  label={problem.label.toUpperCase()}
                  status={problem.category}
                />
                <PMessage>{problem.message}</PMessage>
              </StatusCard>
            );
          })}

          {warnings.map((warning, index) => {
            return (
              <StatusCard key={index}>
                <StatusCommon
                  label={warning.label.toUpperCase()}
                  status={warning.category}
                />
                <PMessage>{warning.message}</PMessage>
              </StatusCard>
            );
          })}
        </StatusInfo>
      </Container>
    </Sidebar>
  );
};
